import React from 'react';

export function Errors() {
  return (
    <span className="invalid-feedback">
      Preencha o campo!
    </span>
  );
}
